import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useProducts = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['products'],
    queryFn: () =>
      api
        .postBackUnitsItemsListFilter({
          postBackUnitsItemsListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
